import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import axios from '../../common/api/axiosConfig';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';


export default function EnhancedMaintenanceTableRow({ row, index, selected, readOnly, handleClickEvent, handleEdit, handleClose, add, closeAdd, setOpen, setErrorMessage, setErrorType }) {

  const intl = useIntl();
  const ApiList = useSelector((state) => state.apiList.apiList);
  const idToken = localStorage.getItem("idToken")

  //values used to determine which text field is focused
  const [focusValues, setFocusValues] = React.useState({
    company: false,
    bac: false,
    fan: false
  })

  //values used in the text fields, NOT the read only fields
  const [values, setValues] = React.useState({
    company: row.companyName,
    bac: row.bac,
    fan: row.fan,
  });
  const [labelId, setLabelId] = React.useState(`enhanced-table-checkbox-${index}`);

  //reads the selected or readOnly lists passed from parent class to create boolean variable
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const isItemSelected = isSelected(row.companyName + row.bac);
  const isReadOnly = (name) => name === readOnly;
  const isItemReadOnly = isReadOnly(row.companyName + row.bac);


  //updates the values of the text fields on change of field
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  function refreshState() {
    setValues({
      company: row.companyName,
      bac: row.bac,
      fan: row.fan,
    })
  }

  React.useEffect(() => {
    refreshState();
  }, [row]);


  // ********************Focus Handlers********************
  //sets text field focus to whichever field is clicked
  const handleCompanyFocus = (event) => {
    setFocusValues({
      company: true,
      bac: false,
      fan: false,
    });
  };

  const handleBacFocus = (event) => {
    setFocusValues({
      company: false,
      bac: true,
      fan: false,
    });
  };

  const handleFanFocus = (event) => {
    setFocusValues({
      company: false,
      bac: false,
      fan: true,
    });
  };

  // updates or creates data in current text fields
  function handleAddBacFan(newCompany, newBac, newFan) {


    //check data here

    const update = {
      oldBacFanAsscn: {
        bac: row.bac,
        fan: row.fan,
        companyName: row.companyName
      },
      bacFanAsscn: {
        bac: newBac,
        fan: newFan,
        companyName: newCompany
      }
    }

    axios.post(ApiList.savebac, update, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {

        if (res.data.statusMessage === 'SUCCESS') {
          /* window.localStorage.setItem('alert', 'success'); */
          setOpen(true)
          setErrorType('success')
          /* setErrorMessage(res.statusMessage) */
          setErrorMessage(intl.formatMessage({ id:res.data.statusMessage, defaultMessage: "Error Found" }))
          ///temporary fix for data transfer
          window.location.reload();

        } else {
          //this is where the message will be set for the toast
          /* window.localStorage.setItem('alert', 'error'); */
          setOpen(true)
          setErrorType('error')
          /* setErrorMessage(res.statusMessage) */
          setErrorMessage(intl.formatMessage({ id:res.data.statusMessage, defaultMessage: "Error Found" }))

        }
        console.log(res.data)
      }).catch(error => {
        /* console.log('error', error)
        window.localStorage.setItem('alert', 'error'); */
        setOpen(true)
        setErrorMessage(intl.formatMessage({ id:error.message.toString().toUpperCase().replace(/ /g,"_"), defaultMessage: error.message }))
        setErrorType('error')
        window.location.reload();
      });
}

// **********************Cell and Row Styling Components**********************
const StyledTableCell = styled(TableCell)(({ theme }) => ({
[`&.${tableCellClasses.head}`]: {
backgroundColor: theme.palette.action.hover,
color: theme.palette.common.black,
fontSize: 16,
width: 0,
fontWeight: 'bold',
},
[`&.${tableCellClasses.body}`]: {
fontSize: 16,
},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
'&:nth-of-type(even)': {
backgroundColor: theme.palette.action.hover,
},
// hide last border
'&:last-child td, &:last-child th': {
border: 0,
},
}));


// **********************Components which render when editing a row**********************
const CheckButton = () =>
<span>
<IconButton aria-label='Confirm' compact="true" className="maintenanceCheckButton" onClick={() => handleAddBacFan(values.company, values.bac, values.fan)} >
<CheckIcon sx={{ color: 'blue' }} />
</IconButton>
</span>;

const CloseButton = () => {
if (add) {
return (
<IconButton aria-label='Close' compact="true" className="maintenanceCloseButton" onClick={closeAdd}>
  <CloseIcon />
</IconButton>
)
} else {
return (
<IconButton aria-label='Close' compact="true" className="maintenanceCloseButton" onClick={() => handleClose()}>
  <CloseIcon />
</IconButton>
)
}
}

const EditGroup = ({ selected, bac, companyName }) => {
if (isItemReadOnly) {
return (
<div>
  <span><CloseButton /></span>
  <span><CheckButton /></span>
</div>
)
} else if (readOnly === null) {
return (
<IconButton aria-label='Edit Row' onClick={(event) => handleEdit(event, row.companyName + row.bac)}>
  <EditIcon />
</IconButton>
)
} else {
return (
<IconButton aria-label='Edit Row: disabled' disabled>
  <EditIcon />
</IconButton>
)
}
}

// **********************Individual Cell components for each row**********************
const CompanyCell = () => {
if (isItemReadOnly) {
return (
<StyledTableCell
  component="th"
  id={labelId}
  scope="row"
  padding="none"
>
  <TextField
    id={values.company + values.bac}
    onClick={(event) => handleCompanyFocus(event)}
    autoFocus={focusValues.company}
    name='company'
    InputProps={{
      readOnly: false,
      size: 'small',
    }}
    variant="outlined"
    value={values.company}
    onChange={handleChange('company')}
  />
</StyledTableCell>
)
} else {
return (
<StyledTableCell
  component="th"
  id="CompanyName"
  aria-label='Company'
  scope="row"
  padding="none"
>
  {row.companyName}
</StyledTableCell>
)
}
}

const BacCell = () => {
if (isItemReadOnly) {
return (
<StyledTableCell
  component="th"
  id="BAC"
  scope="row"
  padding="none"
>
  <TextField
    id={values.bac + values.fan}
    name='bac'
    onClick={(event) => handleBacFocus(event)}
    autoFocus={focusValues.bac}
    InputProps={{
      inputMode: 'numeric',
      pattern: '[0-9]*',
      readOnly: false,
      size: 'small',
    }}
    value={values.bac}
    onChange={handleChange('bac')}
  />
</StyledTableCell>
)
} else {
return (
<StyledTableCell
  component="th"
  id="FAN"
  scope="row"
  padding="none"
>
  {row.bac}
</StyledTableCell>
)
}
}

const FanCell = () => {
if (isItemReadOnly) {
return (
<StyledTableCell
  component="th"
  id={labelId}
  scope="row"
  padding="none"
>
  <TextField
    id={values.company + values.fan}
    onClick={(event) => handleFanFocus(event)}
    autoFocus={focusValues.fan}
    name='fan'
    InputProps={{
      inputMode: 'numeric',
      pattern: '[0-9]*',
      readOnly: false,
      size: 'small',
    }}
    value={values.fan}
    onChange={handleChange('fan')}
    variant="outlined"
  />
</StyledTableCell>
)
} else {
return (
<StyledTableCell
  component="th"
  id={labelId}
  scope="row"
  padding="none"
>
  {row.fan}
</StyledTableCell>
)
}
}


return (
<StyledTableRow
hover
role="checkbox"
aria-checked={isItemSelected}
tabIndex={-1}
key={row.bac + row.fan}
selected={isItemSelected}
>
<TableCell padding="checkbox">
{readOnly === null ? (
  <Checkbox
    color="primary"
    role={"presentation"}
    checked={isItemSelected}
    onClick={(event) => handleClickEvent(event, row.companyName + row.bac)}
    inputProps={{
      'aria-labelledby': labelId,
    }}
  />
) : (
  <Checkbox disabled
    color="primary"
    role={"presentation"}
    checked={isItemSelected}
    inputProps={{
      'aria-labelledby': labelId,
    }}
  />
)}
</TableCell>
<CompanyCell />
<BacCell />
<FanCell />
<TableCell align="right">
<EditGroup bac={row.bac} companyName={row.companyName} />
</TableCell>
</StyledTableRow>
)
}